<template>
  <div class="">
      <!-- Seller Biography -->

      <br />
      <v-card>

        <v-card-title primary-title>
              <div>
                Your biography is
                <hr />

                  <div v-html="biography"></div>

              </div>
        </v-card-title>

       <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn @click="show = !show" flat color="accent">
           Edit
           <v-icon class="ml-1">{{show ? $vuetify.icons.up : $vuetify.icons.down}}</v-icon>

          </v-btn>
        </v-card-actions>

        <v-slide-y-transition>

          <v-card-text v-show="show">
            <hr />
            <v-form width="100px" v-model="valid">
              <v-layout justify-start >
                <div>
                  <b>Do write about:</b>
                  <ul>
                    <li>Write about things you love to do</li>
                    <li>Why you love creating the things you sell</li>
                    <li>How you got started making the things you sell</li>
                    <li>Something you're saving up money to buy yourself</li>
                    <li>Any charity you might be planning to help with your profits</li>
                  </ul>
                </div>
                <div>
                  <b>Don't write about:</b>
                  <ul>
                    <li>
                      Your street address or phone number
                    </li>
                    <li>Don't give out your school name</li>
                    <li>
                      Don't include your last name
                    </li>
                  </ul>
                </div>
              </v-layout>

              <vue-editor v-model="content" :editorToolbar="customToolbar"></vue-editor>

                <v-layout row align-center justify-center>
                  <v-btn class="success" @click="submit"  :disabled="!valid" :loading="inprogress" >Save Changes</v-btn>
                </v-layout>
            </v-form>
            <v-layout row class="heading success--text " v-show="updateSuccess">
              <v-spacer></v-spacer>
              Biography was successfully updated.
              <v-spacer></v-spacer>
            </v-layout>

            <v-layout row class="heading error--text " v-show="errMessage">
              <v-spacer></v-spacer>
              {{errMessage}}
              <v-spacer></v-spacer>
            </v-layout>

          </v-card-text>
        </v-slide-y-transition>

      </v-card>
</div>

</template>

<script>

import {mapState} from 'vuex'
// import utils from '../../../utils.ts'
import firebase from 'firebase/app'
import {VueEditor} from 'vue2-editor' // https://github.com/davidroyer/vue2-editor

export default {
  name: 'SellerBioCard',
  components: {
    VueEditor
  },
  computed: {
    ...mapState({
      biography: state => state.admin.public_settings.biography,
      locked: state => state.admin.public_settings.locked
    })
  },
  props: {

  },
  data () {
    return {
      show: false,
      valid: false,
      inprogress: false,
      updateSuccess: false,
      errMessage: null,
      content: '',
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{'header': 1}, {'header': 2}],
        [{list: 'ordered'}, {list: 'bullet'}],
        [{'color': []}, {'background': []}]
      ]
    }
  },
  watch: {
    show: function (val, old) {
      // Whenever we "show" the edit window, copy the current BIO into it.
      this.content = this.biography
    }
  },
  methods: {
    submit: async function () {
      // Update the password
      this.inprogress = true
      this.errMessage = null
      this.updateSuccess = false

      try {
        // Validate the length (this is just to remove crazy long stuff)
        if (this.content.length > 50000) {
          this.errMessage = 'Your biography is too long. Make it less than 50,000 characters!'
          this.inprogress = false
          return
        }

        if (this.locked) {
          this.errMessage = 'This account is locked. You cannot make changes.'
          this.inprogress = false
          return

        }

        // TODO: Should I remove HTML in here also(?)

        // Do Update
        const bioRef = firebase.firestore()
          .collection('artists')
          .doc(firebase.auth().currentUser.uid)
          .collection('public')
          .doc('settings')

        const rc = await bioRef.set({
          biography: this.content
        }, {merge: true})

        console.log('RC from update:' + JSON.stringify(rc))

        // If all went well, we're logged in as the kid, go to their account
        this.updateSuccess = true
      } catch (err) {
        console.error('Could not update the biograpy: ' + JSON.stringify(err))
        this.errMessage = err.message
      }

      this.inprogress = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
